/**
 * @description
 */
import * as postByCustomerId from './postByCustomerId';

export { postByCustomerId };
